import { TSelectedFilterItem } from '@app.feature/activityFilter/components/SelectedFilterList/SelectedFilterList'
import { TFilterKey } from '@app.feature/activityFilter/modules/constant'
import useActivityFilterStore, {
  TActivityFilterItem,
} from '../../../store/storeActivityFilter'

export const useSelectedFilter = () => {
  const {
    selectedFilter,
    getOrderByKey,
    removeSelectedFilter,
    resetSelectedFilter,
  } = useActivityFilterStore()

  const selectedFilterKeys = Object.keys(selectedFilter)

  const selectedFilterList = (() => {
    const result: TSelectedFilterItem[] = []

    for (const key of selectedFilterKeys) {
      const targetFilter: TActivityFilterItem[] = selectedFilter[key]
      for (const filterItem of targetFilter) {
        result.push({
          id: filterItem.id,
          name: key,
          label: filterItem.label,
          order: getOrderByKey(`${key as TFilterKey}.${filterItem.id}`),
        })
      }
    }

    return result
  })()

  const isEmpty = selectedFilterList.length === 0

  const handleRemoveFilter = (item: TSelectedFilterItem) => {
    removeSelectedFilter({
      name: item.name as TFilterKey,
      filterId: item.id,
    })
  }

  const handleReset = () => {
    resetSelectedFilter()
  }

  return {
    isEmpty,
    selectedFilterList,
    onRemove: handleRemoveFilter,
    onReset: handleReset,
  }
}
